import React from "react";
import CurrencyFormat from '../../../Formatters/CurrencyFormat';
import PropTypes from 'prop-types';

export default function ProductSpecificationsData(minAgeDays, maxAge, minCoverageAmount, maxCoverageAmount) {
    return {
        video: {
            name: "Term vs Permanent Insurance",
            link: "https://player.vimeo.com/video/213549645"
        },
        image: "product-landing/chil/circle1.png",
        specs: [
            {
                title: "Eligibility",
                text: `${minAgeDays} days - ${maxAge} years`,
            },
            {
                title: "Coverage amount",
                text: <span><CurrencyFormat number={minCoverageAmount} whole /> - <CurrencyFormat number={maxCoverageAmount} whole /></span>,
            },
            {
                title: "Who can apply?",
                text: `U.S. citizens or permanent residents ages ${minAgeDays} days - ${maxAge} years are eligible for children's whole life.`
            },
            {
                title: "Extra benefits",
                text: "Coverage doubles at age 18, Guaranteed interest rate of 4%, Less than 50 cents a day for $25,000 of coverage, Fixed premiums, Opportunities to increase coverage up to 10 times the original amount without underwriting"
            }
        ],
        hideNeedsAnalysis: true
    };
}

ProductSpecificationsData.propTypes = {
    minAgeDays: PropTypes.number.isRequired,
    maxAge: PropTypes.number.isRequired,
    minCoverageAmount: PropTypes.number.isRequired,
    maxCoverageAmount: PropTypes.number.isRequired
};



// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/Juve/ProductSpecificationsData.js